import axios from "axios";
import { useState } from "react";

const useResendVerificationEmail = () => {
  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const resetPassword = async (email) => {
    setLoading(true);

    try {
      const result = await axios.post(
        `${process.env.REACT_APP_API_URL}/reset-password/`,
        { email },
        {
          headers: {
            "Content-Type": "application/json",
            "X-CLIENT-API-KEY": process.env.REACT_APP_API_KEY,
          },
        }
      );

      setResponse(result.data);
      setError(null);
    } catch (err) {
      setError(err.response ? err.response.data : err.message);
      setResponse(null);
    }

    setLoading(false);
  };

  return { resetPassword, response, error, loading };
};

export default useResendVerificationEmail;
